var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tarifas" },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "500" },
          model: {
            value: _vm.showInfoDialog,
            callback: function($$v) {
              _vm.showInfoDialog = $$v
            },
            expression: "showInfoDialog"
          }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticStyle: {
                    "font-size": "17px",
                    "margin-left": "10px !important"
                  }
                },
                [_vm._v("Aplicaciones " + _vm._s(_vm.infoTypeReport))]
              )
            ],
            1
          ),
          _c(
            "v-card",
            { attrs: { "max-height": "300", id: "bodyDialogInfo" } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "20px" } },
                _vm._l(_vm.infoItems, function(item) {
                  return _c(
                    "div",
                    { key: item.index, staticClass: "itemInfoDiv" },
                    [
                      _c("li", [
                        _vm._v(
                          "\n            " + _vm._s(item.value) + "\n          "
                        )
                      ])
                    ]
                  )
                }),
                0
              )
            ]
          )
        ],
        1
      ),
      _c(
        "fieldset",
        {
          staticStyle: {
            width: "100%",
            "margin-bottom": "20px",
            display: "flex",
            height: "95%",
            border: "1px solid rgb(220, 220, 220)"
          }
        },
        [
          _c(
            "legend",
            {
              staticStyle: {
                "margin-left": "0.3rem",
                color: "#9e9e9e",
                "font-size": "0.8rem"
              }
            },
            [_vm._v("\n      Generar Reporte\n    ")]
          ),
          _c(
            "v-form",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "center",
                width: "100%"
              },
              model: {
                value: _vm.isFormValid,
                callback: function($$v) {
                  _vm.isFormValid = $$v
                },
                expression: "isFormValid"
              }
            },
            [
              _c(
                "FormFieldsContainer",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center",
                    width: "100%"
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { margin: "20px", width: "50%" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                        [
                          _c("v-autocomplete", {
                            staticStyle: { "margin-right": "20px" },
                            attrs: {
                              items: _vm.flotas,
                              label: "Flotas",
                              multiple: "",
                              chips: "",
                              "deletable-chips": "",
                              "item-text": "__nom_flota",
                              "item-value": "cod_flota",
                              dense: ""
                            },
                            on: {
                              change: function($event) {
                                _vm.buscarVehiculos(
                                  _vm.flotasSeleccionados,
                                  []
                                ) &&
                                  _vm.buscarGrupos(_vm.flotasSeleccionados) &&
                                  _vm.confirmFlotas()
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend-item",
                                fn: function() {
                                  return [
                                    _c(
                                      "v-list-tile",
                                      [
                                        _c("v-checkbox", {
                                          attrs: { label: "Seleccionar todos" },
                                          on: {
                                            change: function($event) {
                                              return _vm.selectAllFlota()
                                            }
                                          },
                                          model: {
                                            value: _vm.checkAllFlotas,
                                            callback: function($$v) {
                                              _vm.checkAllFlotas = $$v
                                            },
                                            expression: "checkAllFlotas"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("v-divider")
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var item = ref.item
                                  var index = ref.index
                                  return [
                                    index === 0
                                      ? _c("v-chip", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.textoComprimido(
                                                  item.__nom_flota
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    index === 1
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "grey--text text-caption",
                                            staticStyle: {
                                              "font-size": "0.75em"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  (+" +
                                                _vm._s(
                                                  _vm.flotasSeleccionados
                                                    .length - 1
                                                ) +
                                                ")\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.flotasSeleccionados,
                              callback: function($$v) {
                                _vm.flotasSeleccionados = $$v
                              },
                              expression: "flotasSeleccionados"
                            }
                          }),
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Grupo",
                              items: _vm.grupos,
                              multiple: "",
                              chips: "",
                              "deletable-chips": "",
                              dense: ""
                            },
                            on: {
                              change: function($event) {
                                _vm.buscarVehiculos(
                                  _vm.flotasSeleccionados,
                                  _vm.gruposSeleccionados
                                ) && _vm.confirmGrupos()
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend-item",
                                fn: function() {
                                  return [
                                    _c(
                                      "v-list-tile",
                                      [
                                        _c("v-checkbox", {
                                          attrs: { label: "Seleccionar todos" },
                                          on: {
                                            change: function($event) {
                                              return _vm.selectAllGrupos()
                                            }
                                          },
                                          model: {
                                            value: _vm.checkAllGrupos,
                                            callback: function($$v) {
                                              _vm.checkAllGrupos = $$v
                                            },
                                            expression: "checkAllGrupos"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("v-divider")
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var item = ref.item
                                  var index = ref.index
                                  return [
                                    index === 0
                                      ? _c("v-chip", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.textoComprimido(item))
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    index === 1
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "grey--text text-caption",
                                            staticStyle: {
                                              "font-size": "0.75em"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  (+" +
                                                _vm._s(
                                                  _vm.gruposSeleccionados
                                                    .length - 1
                                                ) +
                                                ")\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.gruposSeleccionados,
                              callback: function($$v) {
                                _vm.gruposSeleccionados = $$v
                              },
                              expression: "gruposSeleccionados"
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-autocomplete", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          "data-vv-name": "vehiculoRequerido",
                          "error-messages": _vm.errors.collect(
                            "vehiculoRequerido"
                          ),
                          required: "",
                          items: _vm.vehiculos,
                          label: "Vehiculos",
                          multiple: "",
                          chips: "",
                          "deletable-chips": "",
                          dense: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.confirmVehiculos()
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "prepend-item",
                            fn: function() {
                              return [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c("v-checkbox", {
                                      attrs: { label: "Seleccionar todos" },
                                      on: {
                                        change: function($event) {
                                          return _vm.selectAllVehiculo()
                                        }
                                      },
                                      model: {
                                        value: _vm.checkAllVehiculos,
                                        callback: function($$v) {
                                          _vm.checkAllVehiculos = $$v
                                        },
                                        expression: "checkAllVehiculos"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("v-divider")
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "selection",
                            fn: function(ref) {
                              var item = ref.item
                              var index = ref.index
                              return [
                                index === 0
                                  ? _c("v-chip", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.textoComprimido(item))
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                index === 1
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "grey--text text-caption",
                                        staticStyle: { "font-size": "0.75em" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                (+" +
                                            _vm._s(
                                              _vm.vehiculosSeleccionados
                                                .length - 1
                                            ) +
                                            ")\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.vehiculosSeleccionados,
                          callback: function($$v) {
                            _vm.vehiculosSeleccionados = $$v
                          },
                          expression: "vehiculosSeleccionados"
                        }
                      }),
                      _c("v-autocomplete", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          "data-vv-name": "peajeRequerido",
                          "error-messages": _vm.errors.collect(
                            "peajeRequerido"
                          ),
                          required: "",
                          items: _vm.peajes,
                          label: "Peajes",
                          multiple: "",
                          chips: "",
                          "deletable-chips": "",
                          dense: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.confirmPeajes()
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "prepend-item",
                            fn: function() {
                              return [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c("v-checkbox", {
                                      attrs: { label: "Seleccionar todos" },
                                      on: {
                                        change: function($event) {
                                          return _vm.selectAllPeajes()
                                        }
                                      },
                                      model: {
                                        value: _vm.checkAllPeajes,
                                        callback: function($$v) {
                                          _vm.checkAllPeajes = $$v
                                        },
                                        expression: "checkAllPeajes"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("v-divider")
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "selection",
                            fn: function(ref) {
                              var item = ref.item
                              var index = ref.index
                              return [
                                index === 0
                                  ? _c("v-chip", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.textoComprimido(item))
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                index === 1
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "grey--text text-caption",
                                        staticStyle: { "font-size": "0.75em" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                (+" +
                                            _vm._s(
                                              _vm.peajesSeleccionados.length - 1
                                            ) +
                                            ")\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.peajesSeleccionados,
                          callback: function($$v) {
                            _vm.peajesSeleccionados = $$v
                          },
                          expression: "peajesSeleccionados"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "20px",
                            "margin-bottom": "0px"
                          }
                        },
                        [
                          _c("DatePicker", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              label: "Fecha Inicio",
                              max: _vm.fechaMaxima
                            },
                            model: {
                              value: _vm.fechaDesde,
                              callback: function($$v) {
                                _vm.fechaDesde = $$v
                              },
                              expression: "fechaDesde"
                            }
                          }),
                          _c("TimePicker", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: { label: "Hora Inicio" },
                            model: {
                              value: _vm.horaDesde,
                              callback: function($$v) {
                                _vm.horaDesde = $$v
                              },
                              expression: "horaDesde"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "20px",
                            "margin-bottom": "0px"
                          }
                        },
                        [
                          _c("DatePicker", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: { label: "Fecha Fin", max: _vm.fechaMaxima },
                            model: {
                              value: _vm.fechaHasta,
                              callback: function($$v) {
                                _vm.fechaHasta = $$v
                              },
                              expression: "fechaHasta"
                            }
                          }),
                          _c("TimePicker", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: { label: "Hora Fin" },
                            model: {
                              value: _vm.horaHasta,
                              callback: function($$v) {
                                _vm.horaHasta = $$v
                              },
                              expression: "horaHasta"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "center"
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "v-radio-group",
                              {
                                attrs: { row: "" },
                                model: {
                                  value: _vm.row,
                                  callback: function($$v) {
                                    _vm.row = $$v
                                  },
                                  expression: "row"
                                }
                              },
                              [
                                _c("v-radio", {
                                  attrs: { label: "PDF", value: "pdf" }
                                }),
                                _c("v-radio", {
                                  attrs: { label: "EXCEL", value: "xlsx" }
                                }),
                                _c("v-radio", {
                                  attrs: { label: "CSV", value: "csv" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "center"
                                }
                              },
                              [
                                _c("v-checkbox", {
                                  staticStyle: { margin: "10px" },
                                  attrs: { label: "Resumen" },
                                  model: {
                                    value: _vm.resumen,
                                    callback: function($$v) {
                                      _vm.resumen = $$v
                                    },
                                    expression: "resumen"
                                  }
                                }),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "#FFE700" },
                                    on: {
                                      click: function($event) {
                                        return _vm.generarReporte()
                                      }
                                    }
                                  },
                                  [_vm._v("Generar Informe")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("MensajeValidacion", {
        attrs: {
          showDialog: _vm.showValidacionReporteRestricciones,
          titulo: _vm.$t(_vm.tituloValidacion),
          mensaje: _vm.$t(_vm.mensajeValidacion),
          href: _vm.$t(_vm.mensajeHRef),
          mensajeBot: _vm.$t(_vm.mensajeValidacionBot)
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.showValidacionReporteTime,
          titulo: _vm.$t(_vm.tituloValidacion),
          mensaje: _vm.$t(_vm.mensajeValidacion),
          textoBtnSi: _vm.$t("mensajes.mensajesInformes.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesInformes.btnCancelarGeneracion")
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }